import { render, staticRenderFns } from "./homeaside.vue?vue&type=template&id=0f3cf6cc&scoped=true&"
import script from "./homeaside.vue?vue&type=script&scoped=true&lang=js&"
export * from "./homeaside.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./homeaside.vue?vue&type=style&index=0&id=0f3cf6cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3cf6cc",
  null
  
)

export default component.exports